import { Briefcase, HardHat, Heart, Stethoscope } from "lucide-react";

export interface Practice {
  slug: string;
  i18nKey: "personalInjury" | "laborLaw" | "socialSecurity" | "medicalNegligence";
  icon: typeof Briefcase;
}

export const practices: Practice[] = [
  { slug: "personal-injury", i18nKey: "personalInjury", icon: Briefcase },
  { slug: "labor-law", i18nKey: "laborLaw", icon: HardHat },
  { slug: "social-security", i18nKey: "socialSecurity", icon: Heart },
  { slug: "medical-negligence", i18nKey: "medicalNegligence", icon: Stethoscope },
];
